import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const ITEMS = [
  {
    q: "What is an RFQ?",
    a: "A Request for Quotation (RFQ) is a structured sourcing request that defines every commercial, technical and logistics requirement before suppliers respond. RFQ™ replaces email-based requests with a professional workspace built for the way procurement teams actually work.",
  },
  {
    q: "Can I save my RFQ?",
    a: "Yes. Every RFQ auto-saves continuously as a draft inside your Workspace. You can leave at any point and return — your data, attachments, completion state and revision history are preserved.",
  },
  {
    q: "Can I attach specifications?",
    a: "Absolutely. Tech packs, drawings, brand guidelines, color references, test reports, certifications — attach any supporting document. Manufacturers receive everything in one organized request.",
  },
  {
    q: "Can I invite my own suppliers?",
    a: "Yes. Every RFQ can be routed to DeMaxtore's verified Turkish manufacturer network, your own private supplier list, or both — without leaving the Workspace.",
  },
  {
    q: "Can I continue with CommodityBid™?",
    a: "One click. Any RFQ can be promoted into a live CommodityBid™ procurement auction — same requirements, same suppliers, same Workspace. Nothing is re-entered.",
  },
  {
    q: "Can I manage all RFQs inside my Workspace?",
    a: "Yes. Drafts, active RFQs, received quotations, archived requests, revisions and team activity all live inside a single Workspace with role-based access control and an audit log.",
  },
];

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 sm:py-32 border-t border-black/[0.06] bg-[#FAFAFB]"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_2fr] gap-12">
          <div>
            <span className="eyebrow">FAQ</span>
            <h2 className="mt-4 font-display font-black tracking-[-0.035em] text-[40px] sm:text-[52px] leading-[0.98]">
              Questions,
              <br />
              <span className="text-black/40">answered.</span>
            </h2>
            <p className="mt-5 text-[15px] text-black/60 max-w-sm">
              Everything procurement, sourcing and operations teams ask before
              moving their RFQs into a Workspace.
            </p>
          </div>

          <Accordion type="single" collapsible className="w-full" defaultValue="item-0">
            {ITEMS.map((it, i) => (
              <AccordionItem
                key={it.q}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-black/[0.08]"
              >
                <AccordionTrigger className="text-left font-display text-[17px] sm:text-[19px] font-semibold tracking-tight py-5 hover:no-underline">
                  <span className="flex items-baseline gap-3">
                    <span className="font-mono text-[11px] tracking-[0.18em] text-black/35">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {it.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-[14.5px] leading-relaxed text-black/65 pb-5 pl-9 pr-2">
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
